import { Pipe, PipeTransform } from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ContainerMission } from 'src/app/storage/models/container-mission.model';

@Pipe({
    name: 'containerWarning',
    standalone: false
})
export class ContainerWarningPipe implements PipeTransform {

    constructor() { }

    transform(warning: string, container: ContainerMission): string {
      return warning
            .replace('{CONTAINER_ID}', container.containerId)
            .replace('{CONTAINER_QTY}', container.loadedQty.toString())
            .replace('{CONTAINER_LIMIT}', container.limit.toString());
    }

}
